import { useState } from 'react';
import Modal from '@/components/ui/Modal';

/** Pilas cambiadas, o la batería del Ring recargada: fecha y quién (el usuario del CRM). */
interface Props {
  abierto: boolean;
  onCerrar: () => void;
  onGuardar: (datos: Record<string, unknown>) => Promise<void>;
}

export default function ModalPilas({ abierto, onCerrar, onGuardar }: Props) {
  const hoy = new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Madrid' });
  const [fecha, setFecha] = useState(hoy);
  const [nota, setNota] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault();
    setGuardando(true);
    setError(null);
    try {
      await onGuardar({ fecha, nota: nota.trim() || undefined });
      onCerrar();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se ha podido guardar');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal isOpen={abierto} onClose={onCerrar} title="Pilas cambiadas" size="sm">
      <form onSubmit={enviar} className="space-y-4">
        <label className="block">
          <span className="label">Cuándo</span>
          <input type="date" className="input mt-1" value={fecha} onChange={(e) => setFecha(e.target.value)} />
        </label>
        <label className="block">
          <span className="label">Nota</span>
          <input className="input mt-1" value={nota} onChange={(e) => setNota(e.target.value)} placeholder="Tipo de pila, quién lo hizo…" />
        </label>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onCerrar} className="btn-secondary">Cancelar</button>
          <button type="submit" disabled={guardando} className="btn-primary disabled:opacity-50">{guardando ? 'Guardando…' : 'Apuntar'}</button>
        </div>
      </form>
    </Modal>
  );
}
